/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import _ from "lodash";
import React from "react";
import {
  getUtagAuthObject,
  getUtagNeedStates,
  getUtagSessionObject,
} from "../../../utils/utagSession";
import { utag, withUtag } from "../../analytics/analytics";

// Interface for TipsDetails State
interface TipsDetailsState {
  data: any;
}

/**
 * TipsDetails component.
 *
 * @namespace TipsDetails
 */
class TipsDetails extends React.Component<any, TipsDetailsState> {
  constructor(props: any) {
    super(props);
    this.state = {
      data: "",
    };
  }

  componentWillReceiveProps(props: any) {
    //update to analytics
    let authObj = getUtagAuthObject();
    let sessionObj = getUtagSessionObject();
    let needStatesObj = getUtagNeedStates();
    let obj = {
      page_name: window.location.pathname.includes("summary")
        ? "My Tips"
        : "My Results",
      event_name: "wellness_details",
      wellness_contentID: props?.data?.lookup_id,
      wellness_contentName: props?.data?.tip_title,
      wellness_contentType:
        props?.selectedOption === "where" ? "tip_where" : "tip_why",
    };
    let updatedObj = _.merge(
      localStorage.getItem("user-info") ? authObj : {},
      localStorage.getObj("reco-result") ? needStatesObj : {},
      sessionObj,
      obj
    );
    withUtag().then((utag) => utag.view(updatedObj));
  }

  componentDidUpdate = () => {
    if (this.props?.data !== this.state.data) {
      let hashValues = _.split(window.location.hash, "/#");

      window.history.replaceState(
        null,
        "",

        `${window.location.pathname}${hashValues[0]}`
      );

      let updatedHashValues = _.split(window.location.hash, "/#");
      window.history.replaceState(
        null,
        "",

        updatedHashValues.length === 1
          ? `${window.location.href}/#${this.props?.data?.lookup_id}`
          : `${window.location.pathname}${updatedHashValues[0]}/#${
              updatedHashValues[updatedHashValues.length - 1]
            }`
      );
      this.setState({ data: this.props?.data });
    }
  };

  render() {
    const { selectedOption, data } = this.props;
    return (
      <>
        {/* Where to Start Section Start */}
        {selectedOption && selectedOption === "where" && (
          <div className="details-area">
            {/* instructions section Start */}
            <div className="where-to-start--wrapper">
              <div className="lists-area">
                <ul>
                  {/* {data && JSON.stringify(data.where_content)} */}
                  {data &&
                    data?.where_content?.map((item: any) => (
                      <li className="list">{item}</li>
                    ))}
                  {/* <div className="lists-area">
                <ul>
                  <li className="list">
                    Don't have a pet yet? Be prepared – it's a commitment! Think
                    about your living environment. Do you rent or own? Have a
                    yard or a walk-up apartment? These questions and more can
                    help determine if a pet is right for you, and if so, what
                    kind you might want.
                  </li>
                  <li className="list">
                    Though cats and dogs are most common, studies show any pet
                    can help your mental and physical health. So if you have
                    allergies, or your lifestyle isn't right for a certain type
                    of animal, that's ok! You can still enjoy the friendship and
                    benefits of having a pet. Already have a dog? Get moving! A
                    short walk with your furry friend can help your mental and
                    physical health – and your dog's! Sometimes, the simple act
                    of petting or sitting next to your pet can lift your mood.
                    Enjoy its company and both of you will be better for it.
                  </li>
                </ul>
              </div> */}
                </ul>
              </div>
            </div>
            {/* instructions section Ends */}
          </div>
        )}
        {/* Where to Start Section Ends */}

        {/* Why Section Start */}
        {selectedOption && selectedOption === "why" && (
          <div className="details-area">
            <div className="food-details">
              {data && data?.why_content}
              {/* Sometimes you can't help but smile at your pet. There's a reason
              for that! Regularly playing with your pet can help with your
              physical health by helping you maintain your blood pressure and
              cholesterol levels, and your mental health by combating loneliness
              or occasional stress. Plus, they are just so cute! */}
            </div>
          </div>
        )}
        {/* Why Section Ends */}
      </>
    );
  }
}

export default TipsDetails;
